import { Wording } from '@/types';

export const LOVE_WORDING_RO: Wording = {
  components_header_media_content: 'Audio',
  components_header_media_1: 'Meditații',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Ghiduri',
  components_header_text2: 'Blog',
  components_header_members: 'Membrii',
  hero_text: 'Descoperă dragostea prin stele',
  hero_button_text: 'Începe-ți călătoria',
  components_ressources_section_title: 'DRAGOSTE & ASTROLOGIE',
  components_ressources_subheader_text: 'Setul dvs. de instrumente Celestial pentru o perspectivă romantică',
  components_ressources_span_text: 'Scufundați-vă în universul nostru de podcasturi și articole centrate pe dragoste, compatibilitate cu zodiacul și conexiune cosmică. Indiferent dacă sunteți în căutarea clarității sufletului pereche sau vă decodați tiparele de relație, resursele noastre vă ghidează către o înțelegere mai profundă prin stele.',
  components_ressources_card_1_title: 'Discuții de dragoste despre zodiac',
  components_ressources_card_1_text: 'Explorați episoade de podcast sincere, care explorează limbajul emoțional al fiecărui semn, compatibilitatea cu dragostea, pasiunea și creșterea personală în relații.',
  components_ressources_card_2_title: 'Blog de dragoste',
  components_ressources_card_2_text: 'Citiți perspective și reflecții despre modul în care fiecare semn iubește, vindecă și se conectează. De la sinastrie la romantism planetar, blogul nostru este ghidul tău pentru dragostea astrologică.',
  components_ressources_link: 'Explorează mai departe',
  components_notes_and_google_title_1: 'Astrologie romantică',
  components_notes_and_google_title_2: 'Obiceiuri de dragoste',
  components_notes_and_google_title_3: 'Reflecțiile de dragoste ale ascultătorilor',
  components_review_google_text: 'Ce spun ascultătorii noștri',
  media_content_section_title: 'PODCAST DE DRAGOSTE ȘI ZODIAC',
  media_content_section_subheader_text: 'Discuție reală despre romantismul cosmic',
  text_media_1: 'Acordați episoade profunde și revelatoare despre potriviri astrologice, modele emoționale și dinamică romantică.',
  text_media_2: '',
  media_content_section_button_more: 'Ascultă acum',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Povești și perspective astrologice de dragoste',
  text2_section_button_more: 'Încărcați mai multe',
  components_text1_section_title: 'GHIDURI',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: '',
  components_footer_text: 'Lăsați stelele să vă ghideze povestea de dragoste',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Număr de înregistrare',
  components_footer_legal: 'Legal',
  components_footer_terms: 'Termeni și condiții',
  components_footer_privacy: 'Politica de confidențialitate',
  button_load_more: 'Încărcați mai multe',
  page_media_2_content_hero_text: '',
  page_media_content_menu_antistress: '',
  page_media_content_menu_mindfulness: '',
  page_media_content_menu_energyboost: '',
  page_media_content_menu_mantra: '',
  page_media_1_content_hero_text: 'Dragoste și zodiac: episoade podcast',
  page_media_content_menu_compatibility: 'Compatibilitate',
  page_media_content_menu_love: 'Dragoste',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Explorați dragostea prin astrologie',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Articole',
  enter_email_title: 'Vă rugăm să introduceți adresa dvs. de e-mail pentru a continua',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Intră',
  components_login_success_text: 'Conectare reușită!',
  components_card_link_media_content: 'Ascultă acum',
  components_card_link_text2_content: 'Citiți articole',
  components_card_link_text1_content: '',
  france: 'Franţa',
  cyprus: 'Cipru',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditaţie',
  page_media_content_menu_all: 'Toate',
};